module.exports = "/static/assets/6ea9a9d8b467f46cb1744f87b263a355.png";